export const MINIMUM_WORD_COUNT_FOR_PASSAGE_LEVEL_PROMPTS = 4;
export const MINIMUM_WORD_COUNT_TO_AUTO_HIGHLIGHT = MINIMUM_WORD_COUNT_FOR_PASSAGE_LEVEL_PROMPTS;
